import React, { useContext } from 'react';
import {
  Field,
  SitecoreContext,
  withSitecoreContext,
  WithSitecoreContextProps,
} from '@sitecore-jss/sitecore-jss-react';
import './index.scss';
import QuantityPicker from '../QuantityPicker/QuantityPicker';
import { APIWebstoreContext } from '../../context/globalContext';
import { postAPICall } from '../../dataFetcher/axiosMethodCalls';
import { CartItemsDetails } from '../Product/StandardProductCartDetails/StandardProductCartDetails';
import { MAX_CART_QUANTITY } from '../../utils/constants';

export interface QuantityFieldsProps {
  orderId: string;
  cartItem: CartItemsDetails;
}

type QuantityProps = WithSitecoreContextProps & {
  fields: {
    itemMaxQuantity?: Field<number>;
  };
  properties: {
    divId: string;
    removeLinkId: string;
  };
  quantityFields: QuantityFieldsProps;
  quantityUpdated?: any;
  sitecoreContext: SitecoreContext & { pageEditing: boolean };
};

const Quantity = ({
  fields,
  quantityFields,
  quantityUpdated,
}: QuantityProps): React.JSX.Element => {
  const { state, dispatch } = useContext(APIWebstoreContext);

  const quantityUpdate = (value: number) => {
    if (quantityFields?.cartItem?.priceOption?.quantity) {
      quantityFields.cartItem.priceOption.quantity = value;
    }
    QuantityUpdatePostCall(value);
  };

  function QuantityUpdatePostCall(quantity: number) {
    const quantityUpdateRequest = {
      OrderId: quantityFields.cartItem.orderId,
      lineItemId: quantityFields.cartItem.lineItemId,
      Quantity: quantity,
    };

    postAPICall(
      `${process.env.REACT_APP_CART_URL}/CartOrder/updatequantity`,
      quantityUpdateRequest
    ).then(function (response: any) {
      if (response && response.status === 200) {
        quantityUpdated();
        if (dispatch) {
          dispatch({
            type: 'CART_UPDATE',
            payload: {
              toggleCartQuantityLoad: !state?.toggleCartQuantityLoad,
              toggleOrderSummaryLoad: !state?.toggleOrderSummaryLoad,
            },
          });
        }
      }
    });
  }

  return (
    <div className="quantity">
      <div id="test" className="quantitydiv">
        <div className="quantitymaindiv">
          <QuantityPicker
            min={1}
            value={quantityFields.cartItem.priceOption.quantity}
            onChange={quantityUpdate}
            max={
              fields.itemMaxQuantity?.value === null
                ? MAX_CART_QUANTITY
                : fields.itemMaxQuantity?.value
            }
          />
        </div>
      </div>
      <br />
    </div>
  );

  return <></>;
};

export default withSitecoreContext()(Quantity);
